import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const XCircleFillIcon = (props?: SvgProps) => (
  <svg
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#E4E5E7"
    />
    <path
      d="M15.2929 7.29312C15.6834 6.9026 16.3164 6.9026 16.7069 7.29312C17.0974 7.68363 17.0974 8.31662 16.7069 8.70713L13.414 12L16.7069 15.2929L16.7759 15.3684C17.0963 15.7611 17.073 16.3408 16.7069 16.7069C16.3408 17.073 15.7611 17.0963 15.3684 16.7759L15.2929 16.7069L12 13.414L8.70713 16.7069C8.31662 17.0974 7.68363 17.0974 7.29312 16.7069C6.9026 16.3164 6.9026 15.6834 7.29312 15.2929L10.586 12L7.29312 8.70713L7.22411 8.63162C6.90371 8.23885 6.92699 7.65924 7.29312 7.29312C7.65924 6.92699 8.23885 6.90371 8.63162 7.22411L8.70713 7.29312L12 10.586L15.2929 7.29312Z"
      fill="#474A53"
    />
  </svg>
)
